export default "__VITE_ASSET__DZrlkSPv__"